import { styled } from '@mui/system';
import { Slider } from '@mui/material';

import { timeLanguageFormat, toTime } from 'utils';

import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

const SliderRoot = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-root':{
    display: 'flex',
    alignItems: 'center'
  },
  'span[data-index="0"] > span > span': {
    textAlign: 'right',
    marginRight: theme.spacing(3)
  },
  'span[data-index="1"] > span > span': {
    textAlign: 'left',
    marginLeft: theme.spacing(3)
   },
  "& .MuiSlider-valueLabel": {
    background: 'transparent',
    color: theme.vars.palette.primary.main,
    lineHeight: '16px',
    whiteSpaceCollapse: 'break-spaces',
  },
  "& .MuiSlider-valueLabelLabel": {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  "& .MuiSlider-rail": {
    background: theme.vars.palette.secondary.main,
    opacity: 'unset',
    height: theme.spacing(0.25)
  },
  "& .MuiSlider-track": {
    height: theme.spacing(0.25)
  }
}));

const SliderPicker = ({ lngCode, selectedDate, time, minTime, staticMinTime, maxTime, staticMaxTime, optionName, step, ...props }) => {
  const { t, dateFnsLocaleData } = useOnlineBookingLocale();

  const isHebrew = dateFnsLocaleData?.code === 'he';

  const getAriaValueText = (time) => timeLanguageFormat(lngCode, selectedDate.toISOString().split('T')[0] + ' ' + toTime(parseInt(time/60),parseInt(time%60)));
  const timeLabelFormat = (time) => <>{getAriaValueText(time)}</>

  const valueLabelFormat = (_, index) => {
    const time = timeLabelFormat(index === 0 ? minTime : maxTime)
    const newTime = time.props.children.replace(" ", "\n")
    return { ...time, props:{ children: newTime} };
  }
  return (
    <SliderRoot {...{step, valueLabelFormat, getAriaValueText}}
      slotProps={{
        thumb: {sx:{marginRight: `${isHebrew ? '-1em' : 'initial'}` }},
        valueLabel: {sx: {whiteSpace: 'pre', width: '-webkit-max-content'}}
      }}
      value={[minTime, maxTime]}
      min={staticMinTime}
      max={staticMaxTime}
      valueLabelDisplay="on"
      getAriaLabel={(index) => t(`ariaLabel.${index === 0 ? 'minimum' : 'maximum'}`, { option: optionName })}
      {...props}
    />
  );
}

export default SliderPicker;
